import React, { useState,useEffect } from "react";
import { Navbar, Nav, Offcanvas, Spinner } from "react-bootstrap";
import "./Layout.css";
import { Link, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "react-toastify";
import { routesConfig } from "../PrivateRoutes/routesConfig";

// const adminSidebarLinks = [
//   { to: "/dashboard", icon: "bi-house-door", label: "Dashboard" },
//   { to: "/banners", icon: "bi-people", label: "Banners" },
//   { to: "/products", icon: "bi-gear", label: "Products" },
//   { to: "/banners50", icon: "bi-gear", label: "Banners50" },
//   { to: "/testimonials", icon: "bi-gear", label: "Testimonials" },
//   { to: "/blogs", icon: "bi-gear", label: "Blogs" },
//   { to: "/affiliates", icon: "bi-gear", label: "Affiliates" },
//   { to: "/orders", icon: "bi-gear", label: "Orders" },
//   { to: "/history", icon: "bi-gear", label: "History" },
// ];

// const distributorSidebarLinks = [
//   { to: "/dist/dashboard", icon: "bi-house-door", label: "Dashboard" },
//   { to: "/sale-history", icon: "bi-people", label: "Banners" },
//   { to: "/teams", icon: "bi-gear", label: "Products" },
// ];

export default function Layout() {
  const { user, logout } = useAuth();

  const location = useLocation();

  console.log(user);

  const [loading, setLoading] = useState(false);

  const [showSidebar, setShowSidebar] = useState(false);
  const toggleSidebar = () => setShowSidebar((s) => !s);


  // // Auto-close on route change (for mobile)
  // useEffect(() => {
  //   if (window.innerWidth < 992 && showSidebar) {
  //     toggleSidebar();
  //   }
  // }, [location.pathname]); // runs whenever route changes

  const handleLogout = async () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      toast.info("logout successful");
    }, 600);

    setTimeout(async () => {
      await logout();
    }, 1000);
  };

  // Decide which links to show
  // let sidebarLinks = [];

  // if (user?.role === "admin") {
  //   sidebarLinks = adminSidebarLinks;
  // } else if (user?.role === "distributor") {
  //   sidebarLinks = distributorSidebarLinks;
  // }

  // filter links by user role
  let links = [];
  links = routesConfig.filter((route) => route.roles.includes(user?.role));

  return (
    <div className="admin-wrapper">
      {/* TOPBAR */}
      <Navbar bg="dark" variant="dark" expand="lg" className="px-3 topbar">
        <i
          className="bi bi-list text-white me-3 menu-icon"
          onClick={toggleSidebar}
          aria-label="Toggle sidebar"
          role="button"
        />
        <Navbar.Brand href="#!" className="fw-bold">
          auraskinpremium
        </Navbar.Brand>

        <Nav
          className="nav-custom ms-auto"
          style={{ display: "flex", flexDirection: "row" }}
        >
          <Nav.Link as={Link} to={"/profile"} className="text-white me-3">
            {/* Always show icon */}
            <i className="bi bi-person-circle" style={{ fontSize: "20px" }} />
            {/* Show text only on lg+ screens */}
            {user ? (
              <span className="ms-1 d-none d-lg-inline">{user.user_name}</span>
            ) : (
              <span className="ms-1 d-none d-lg-inline">My Profile</span>
            )}
          </Nav.Link>

          <Nav.Link
            href="#!"
            // as={Link}
            // to={"/login"}
            onClick={handleLogout}
            disabled={loading}
            className="text-danger fw-bold"
          >
            {loading ? (
              <Spinner size="sm" />
            ) : (
              <>
                {" "}
                <i
                  className="bi bi-box-arrow-right"
                  style={{ fontSize: "20px" }}
                />
                <span className="ms-1 d-none d-lg-inline">Logout</span>
              </>
            )}
          </Nav.Link>
        </Nav>
      </Navbar>

      <Offcanvas
      show={showSidebar}
      onHide={toggleSidebar}
      scroll
      backdrop
      placement="start"
      className="sidebar"
      responsive="lg"
    >
      <Offcanvas.Header
        closeButton
        className="border-bottom border-secondary"
      >
        <Offcanvas.Title className="text-white">Navigation</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Nav className="flex-column sidebar-nav">
          {links.length > 0 ? (
            links.map((link) => (
              <Nav.Link
                as={Link}
                to={link.path}
                key={link.path}
                active={location.pathname === link.path}
                onClick={() => {
                  // still handle mobile click
                  if (window.innerWidth < 992) {
                    toggleSidebar();
                  }
                }}
              >
                <i className={`bi ${link.icon} me-2`} /> {link.label}
              </Nav.Link>
            ))
          ) : (
            <div className="px-3 text-muted fs--1">No menu available</div>
          )}
        </Nav>
      </Offcanvas.Body>
    </Offcanvas>

      {/* SIDEBAR */}
      {/* <Offcanvas
        show={showSidebar}
        onHide={toggleSidebar}
        scroll
        backdrop
        placement="start"
        className="sidebar"
        responsive="lg"
      >
        <Offcanvas.Header
          closeButton
          className="border-bottom border-secondary"
        >
          <Offcanvas.Title className="text-white">Navigation</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body style={{overflowY:'scroll'}}>
          <Nav className="flex-column sidebar-nav">
            {links.length > 0 ? (
              links.map((link) => (
                <Nav.Link
                  as={Link}
                  to={link.path}
                  key={link.path}
                  active={location.pathname === link.path}
                >
                  <i className={`bi ${link.icon} me-2`} /> {link.label}
                </Nav.Link>
              ))
            ) : (
              <div className="px-3 text-muted fs--1">No menu available</div>
            )}
           
          </Nav>
        </Offcanvas.Body>
      </Offcanvas> */}

      {/* CONTENT */}
      <main className="content p-4">
        <Outlet />
      </main>
    </div>
  );
}

// const handleLogin = async (e) => {
//   e.preventDefault();
//   setLoading(true);

//   try {
//     const res = await login(formData.user_name, formData.password);

//     if (!res.success) {
//       toast.error(res.error || "Login failed. Please try again.");
//       console.error("Login error:", res);
//       setLoading(false);
//       return;
//     }

//     toast.success("Login successful 🎉");

//     // ⏳ Keep loader visible for 1.5s before redirect
//     setTimeout(() => {
//       if (res.link) {
//         window.location.href = res.link;
//       }
//       setLoading(false); // stop loader right before/after redirect
//     }, 1500);
//   } catch (err) {
//     console.error("Unexpected login error:", err);
//     toast.error("Something went wrong. Please try again.");
//     setLoading(false);
//   }
// };
